import type { FunctionComponent, PropsWithChildren } from 'react';

import { DraftVersionStoreProvider } from '../job-profile-section/DraftVersionStoreProvider';

// JSA url-tile module Provider. Wraps a whole tile surface (board page + its
// tiles, or the dashboard) in a SINGLE draft-version store so an edit made in
// one tile (e.g. the job-profile tile creating a draft version) is visible in a
// sibling tile (e.g. the compare tile reading that draft). The store is keyed by
// item id, not by architecture, so a single shared instance is safe even when
// tiles for several architectures are open at once.
//
// Architecture-specific providers (theme, onboarding changeset) live in
// JobArchitectureScopeProvider, applied per tile / per page from the tile's own
// architecture id.
export const JobArchitectureUrlTilesProvider: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <DraftVersionStoreProvider>{children}</DraftVersionStoreProvider>
);
